import { createStore, debug } from 'easy-peasy';
import userInfoService from '../services/user-info.service';
import model from './model';
const store: any = createStore(model, {
  // 👇 provide injections to our store
  injections: { userInfoService },
});

if (process.env.NODE_ENV === 'development') {
  console.log('STATE : ', debug(store.getState()));
  console.log('ACTIONS : ', debug(store.getActions()));
}

export default store;
